export function shareOnFacebook(url: string) {
  const navUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + getUrlWithoutQueryParams(url);
  window.open(navUrl, '_blank');
}

export function shareOnTwitter(url: string) {
  const content = isApp()
    ? `Check out this amazing tool of Quicktools by Picsart. Every editing tool you need, all in one place. For free. ${getUrlWithoutQueryParams(
        url,
      )}`
    : `Check out Quicktools by Picsart. Every editing tool you need, all in one place. For free.  ${getUrlWithoutQueryParams(
        url,
      )}`;

  const navUrl = 'https://twitter.com/intent/tweet?text=' + content;

  window.open(navUrl, '_blank');
}

export function shareOnLinkedIn(url: string) {
  const navUrl =
    'https://www.linkedin.com/shareArticle?mini=true&url=' + getUrlWithoutQueryParams(url);

  window.open(navUrl, '_blank');
}

export function shareOnEmail(url: string) {
  const body = isApp()
    ? `Check out this amazing tool of Quicktools by Picsart. Every editing tool you need, all in one place. For free. ${getUrlWithoutQueryParams(
        url,
      )}`
    : `Check out Quicktools by Picsart. Every editing tool you need, all in one place. For free.  ${getUrlWithoutQueryParams(
        url,
      )}`;

  const content = `mailto:?subject=Quicktools by Picsart&body=` + body;

  window.open(content, '_blank');
}

const isApp = () => {
  return process.env.NX_ANALYTICS_TOOL_NAME !== 'quicktools_homepage';
};

export const getPageName = () => {
  const partialPaths = window.location.pathname.split('/');
  if (partialPaths.length < 4) {
    const path = partialPaths[partialPaths.length - 2];
    return path != '' ? path : 'landing_page';
  } else {
    const path = partialPaths[partialPaths.length - 1];
    return path != '' ? path : 'landing_page';
  }
};

export const getUrlWithoutQueryParams = (url: string) => {
  const urlParts = url.split('?');
  return urlParts[0];
};
